.flex {
  display: flex;
}

.ribbon {
  background: var(--main-text);
  line-height: 46px;
  padding: 0 0 0 20px;
  justify-content: space-between;
  color: white;
}

.ribbon .ribbon-title {
  font-size: 22px;
  margin-right: auto;
}

.ribbon .ribbon-title > div {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.ribbon > div {
  padding: 0 20px;
  border-left: 1px solid white;
  white-space: nowrap;
}

.ribbon svg {
  fill: white;
  width: 1.5rem;
}

.ribbon .identity > div {
  padding-left: 10px;
}

.menu {
  font-size: 15px;
  position: absolute;
  right: 0;
  list-style: none;
  background-color: var(--main-background);
  border: 1px solid var(--menu-border);
  box-shadow: 0 0 10px var(--shadow);
  z-index: 1;
  margin: 0;
  padding: 0;
  min-width: 200px;
}

.menu a {
  padding: 10px 30px;
}

.menu a:hover {
  cursor: pointer;
  background-color: var(--hover-dark);
  color: #000;
}

.ribbon img.logo {
  max-height: 35px;
  padding-right: 10px;
}
